<template>
    <div>
        <AdminNavigation/>
        Admin Home
    </div>
</template>

<script>
    import AdminNavigation from '../AdminNavigation'

    export default {
        name: 'AdminOrders',
        components: {
            AdminNavigation
        }
    }
</script>

<style scoped>

</style>